<template>
  <div>
    <span v-if="label" :class="{'h6': !editable}">{{ label }}</span>
    <div v-if="editable" class="input-group mt-2">
      <div class="input-group-prepend">
        <div class="btn btn-secondary" role="checkbox"
             @click="revealed = !revealed">
          <span class="fas" :class="revealed ? 'fa-eye' : 'fa-eye-slash'"></span>
        </div>
      </div>
      <input type="hidden" :name="field_name" value="" :disabled="!value">
      <input class="form-control" :type="revealed ? 'text' : 'password'" v-model="value" :name="field_name" :id="field_name">
    </div>
    <div v-else class="d-flex align-items-center">
      <div class="btn btn-sm btn-secondary mr-3" role="checkbox"
           @click="revealed = !revealed">
        <span class="fas" :class="revealed ? 'fa-eye' : 'fa-eye-slash'"></span>
      </div>
      <p class="text-muted m-0">{{ revealed ? value : 'Hidden' }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RevealableInfo",
    props: {
      label: null,
      value: null,
      field_name: null
    },
    data(){
      return {
        revealed: false
      }
    },
    computed: {
      editable(){
        return !!this.field_name
      }
    }
  }
</script>
